// Constants
import { ONBOARDING_INIT_LOCAL_STORAGE } from 'constants/app.constants';
// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
// Types
import type { AuthWatcherHandlersBuilderType } from '../types/auth-watcher.handlers.type';

const isAboutToAccomplishOneMinuteToExpireSession = (sessionExpiresAt = ''): boolean => {
  const sessionExpirationTime = new Date(sessionExpiresAt).getTime();
  const currentTime = new Date().getTime();
  const oneMinuteInMilliseconds = 60 * 1000;

  return sessionExpirationTime - currentTime <= oneMinuteInMilliseconds;
};

const isSuccessContainerVisible = (
  currentState: AuthWatcherHandlersBuilderType['currentState']
): boolean =>
  [
    AppStatesEnumeration.SUCCESS,
    AppStatesEnumeration.CHECKOUT_SIGNED,
    AppStatesEnumeration.CHECKOUT_SIGNED_PENDING,
  ].includes(currentState as AppStatesEnumeration);

const isOnboardingTimeout = (): boolean => {
  const onboardingInit = new Date(localStorage.getItem(ONBOARDING_INIT_LOCAL_STORAGE) || '');
  onboardingInit.setMinutes(onboardingInit.getMinutes() + 29);

  return new Date() >= onboardingInit;
};

export {
  isAboutToAccomplishOneMinuteToExpireSession,
  isSuccessContainerVisible,
  isOnboardingTimeout,
};
